/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'

class Cities extends React.Component {
  constructor(props) {
    super(props)
    //
    this.state = {
      Cities: [],
      printInfo: [],
      lengthProducts: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      modalDelete: false,
      sortData: [
        {name: 'ردیف', value: 'id', sorted: false, direction: null, sortable: false},
        {name: 'نام استان', value: 'provinceName', sorted: false, direction: null, sortable: true},
        {name: 'نام شهر', value: 'cityName', sorted: false, direction: null, sortable: true},
        {name: 'عرض جغرافیایی', value: 'latitude', sorted: false, direction: null, sortable: false},
        {name: 'طول جغرافیایی', value: 'longitude', sorted: false, direction: null, sortable: false},
        {name: 'وضعیت فعال', value: 'id', sorted: false, direction: null, sortable: false},
        {name: 'ویرایش', value: 'id', sorted: false, direction: null, sortable: false},
        {name: 'حذف', value: 'id', sorted: false, direction: null, sortable: false}
      ]
    }
  }

  getAllCity = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    http
      .get(`${BASE_REPORT.BASE_REPORT_CITY}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          $('.showBaseTable').fadeIn()

          if (!exportStatus) {
            this.setState({
              Cities: res.data.object.result,
              lengthProducts: res.data.object.countAll
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: res.data.object.result
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
        }
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    this.getAllCity(false)
  }

  activate = (numRow) => {
    let status = this.state.Cities[numRow].enabled
    if (status) {
      let id = this.state.Cities[numRow].cityId
      let data = {
        id: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DISABLE_CITY}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllCity(false)
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.Cities[numRow].cityId
      let data = {
        id: id
      }
      const token = sessionStorage.getItem('accessToken')

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ENABLE_CITY}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllCity(false)
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteCity = (numId) => {
    sessionStorage.setItem('selectedRow', numId)

    let cityId = this.state.Cities[numId].cityId
    let cityName = this.state.Cities[numId].cityName
    sessionStorage.setItem('cityId', cityId)
    sessionStorage.setItem('cityName', cityName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('cityId')
    sessionStorage.removeItem('cityName')
  }

  deleteOk = () => {
    const token = sessionStorage.getItem('accessToken')
    var selectedRow = sessionStorage.getItem('selectedRow')
    let cityId = sessionStorage.getItem('cityId')
    let data = {
      id: cityId
    }
    http
      .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DELETE_CITY}`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          message.success('شهر با موفقیت حذف شد')
          this.state.Cities.splice(selectedRow, 1)
          this.setState(this.state.Cities)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllCity(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllCity(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllCity(false)
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let name = $('#name').val()
    let latitude_min = $('#latitude_min').val()
    let latitude_max = $('#latitude_max').val()
    let longitude_max = $('#longitude_max').val()
    let longitude_min = $('#longitude_min').val()
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (name !== '' && name.length) {
      filter.name = name
    }
    if (latitude_max !== '' && latitude_max.length) {
      filter.latitude_max = latitude_max
    }
    if (latitude_min !== '' && latitude_min.length) {
      filter.latitude_min = latitude_min
    }
    if (longitude_max !== '' && longitude_max.length) {
      filter.longitude_max = longitude_max
    }
    if (longitude_min !== '' && longitude_min.length) {
      filter.longitude_min = longitude_min
    }
    return filter
  }

  filter() {
    this.getAllCity(false)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${BASE_REPORT.BASE_REPORT_CITY}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            excelReport: res.data.object.result
          })
          this._export.save(this.state.excelReport)
        }
      })
  }

  getPrintInfo = () => {
    this.getAllCity(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {pageNumber, pageSize} = this.state
    const cityName = sessionStorage.getItem('cityName')
    let name = cookie.load('name')
    let columns = ['ردیف', 'نام استان', 'نام شهر', 'عرض جغرافیایی', 'طول جغرافیایی']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست شهر ها"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((city, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{city.provinceName}</td>
                  <td>{city.cityName}</td>
                  <td>{city.latitude}</td>
                  <td>{city.longitude}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="لیست شهر ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'provinceName'}
                field={'provinceName'}
                title={'استان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'cityName'}
                field={'cityName'}
                title={'شهر'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'latitude'}
                field={'latitude'}
                title={'عرض جغرافیایی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'longitude'}
                field={'longitude'}
                title={'طول جغرفیایی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>لیست شهر ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/addCity'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام</label>
                  <input className="form-control" id="name" type="text" />
                </div>
                <div className="formComponent">
                  <label>عرض جغرافیایی از</label>
                  <input className="form-control" id="latitude_min" type="number" />
                </div>
                <div className="formComponent">
                  <label>عرض جغرافیایی تا</label>
                  <input className="form-control" id="latitude_max" type="number" />
                </div>

                <div className="formComponent">
                  <label>طول جغرافیایی از</label>
                  <input className="form-control" id="longitude_min" type="number" />
                </div>
                <div className="formComponent">
                  <label>طول جغرافیایی تا</label>
                  <input className="form-control" id="longitude_max" type="number" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.Cities.map((city, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{city.provinceName}</td>
                      <td>{city.cityName}</td>
                      <td>{city.latitude}</td>
                      <td>{city.longitude}</td>
                      <td>
                        <button onClick={() => this.activate(index)}>
                          {city.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <Link to={`editCity/${city.cityId}`}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.deleteCity(index)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProducts}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف شهر</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف شهر {cityName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف شهر
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Cities
